export const ROLE_LIST = [
  {
    label: "all",
    value: "",
  },
  {
    label: "Owner",
    value: "Owner",
  },
  {
    label: "Admin",
    value: "Admin",
  },
  {
    label: "Billing",
    value: "Billing",
  },
  {
    label: "Technical",
    value: "Technical",
  },
  {
    label: "User",
    value: "User",
  },
];
